export enum actionTypes {
    SET_JACKPOTS = 'JACKPOTS:SET',
    SET_CASINO_JACKPOT = 'CASINO_JACKPOT:SET'
}
